import { NgModule } from '@angular/core';
import { FiFilePreviewComponent } from './file-preview.component';
import { CommonModule } from '@angular/common';

@NgModule({
    imports: [CommonModule],
    declarations: [FiFilePreviewComponent],
    exports: [FiFilePreviewComponent],
})
export class FiFilePreviewModule {}
